export const VEHICLE_HISTORY_BOOLEAN_FIELDS = [
  'has_carfax',
  'carfax_one_owner',
  'auto_check',
] as const

const VEHICLE_HISTORY_BOOLEAN_FIELD_SET = new Set<string>(VEHICLE_HISTORY_BOOLEAN_FIELDS)

export function isVehicleHistoryBooleanField(field: string): boolean {
  return VEHICLE_HISTORY_BOOLEAN_FIELD_SET.has(String(field || '').trim())
}

export function normalizeBooleanLike(value: unknown): boolean | undefined {
  if (value === true || value === false) return value
  if (value == null) return undefined

  if (typeof value === 'number') {
    if (value === 1) return true
    if (value === 0) return false
    return undefined
  }

  const normalized = String(value).trim().toLowerCase()
  if (!normalized) return undefined
  if (['1', 'true', 'yes', 'y'].includes(normalized)) return true
  if (['0', 'false', 'no', 'n'].includes(normalized)) return false
  return undefined
}

export function formatBooleanDisplayValue(value: unknown): string {
  const normalized = normalizeBooleanLike(value)
  if (normalized === undefined) return 'empty'
  return normalized ? 'Yes' : 'No'
}
